import React, { useState } from "react";
import styles from "./BannerDropdownList.module.css";
import PropTypes from "prop-types";

import FeedItemOptionsDropdown from "../FeedItemOptionsDropdown";
import BannerInformationDropdown from "../BannerInformationDropdown";
import BannerItem from "../BannerItem";
import dayjs from "dayjs";

/**
 * Interactive component.
 * A list of dropdowns with a Banner feed item's properties.
 */
export function BannerDropdownList({
  optionsConfig,
  setOptionsConfig,
  bannerInformation,
  setBannerInformation,
  isNew
}) {
  // Banner Info dropdown
  const [isOpen, setIsOpen] = useState(false);

  // Feed item options dropdown
  const [isFeedOpen, setIsFeedOpen] = useState(false);
  const [sendUpdate, setSendUpdate] = useState(true);

  const current = new Date();
  const date = `${
    current.getMonth() + 1
  }/${current.getDate()}/${current.getFullYear()}`;

  // const [optionsConfig, setOptionsConfig] = useState(feedItem.optionsConfig);

  const handleSendUpdate = () => {
    setSendUpdate(!sendUpdate);
  };

  return (
    <div className={styles.container}>
      {isOpen && !isFeedOpen ? (
        ""
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            <FeedItemOptionsDropdown
              isOpen={isFeedOpen}
              onClick={() => setIsFeedOpen((isFeedOpen) => !isFeedOpen)}
              optionsConfig={optionsConfig}
              setOptionsConfig={setOptionsConfig}
              isEdit={isNew}
              sendUpdate={sendUpdate}
              setSendUpdate={handleSendUpdate}
            />
          </div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "50%",
            }}
          ></div> */}
        </div>
      )}

      {!isOpen && isFeedOpen ? (
        ""
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            <BannerInformationDropdown
              isOpen={isOpen}
              bannerInformation={bannerInformation}
              setBannerInformation={setBannerInformation}
              onClick={() => setIsOpen((isOpen) => !isOpen)}
            />
          </div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "50%",
            }}
          ></div> */}
        </div>
      )}
    </div>
  );
}

BannerDropdownList.propTypes = {
  /**
   * Object that contains all the Banner feed item's properties.
   */
  feedItem: PropTypes.shape({
    type: PropTypes.string,
    options: PropTypes.shape({
      title: PropTypes.string,
      permissions: PropTypes.arrayOf(
        PropTypes.oneOf(["IBO", "PLA", "EM", "DIA"])
      ),
      familyReunions: PropTypes.arrayOf(PropTypes.string),
      diamonds: PropTypes.arrayOf(PropTypes.string),
      groups: PropTypes.arrayOf(PropTypes.string),
      platforms: PropTypes.arrayOf(PropTypes.oneOf(["PC", "Apple", "Android"])),
      incompatiblePlatforms: PropTypes.arrayOf(
        PropTypes.oneOf(["PC", "Apple", "Android"])
      ),
      publishStatus: PropTypes.oneOf([
        "Unpublished",
        "Published",
        "Archived",
        "Storaged",
      ]),
      publishDate: PropTypes.shape({
        date: PropTypes.string,
        time: PropTypes.string,
        priority: PropTypes.number,
      }),
      removalDate: PropTypes.shape({
        date: PropTypes.string,
        time: PropTypes.string,
      }),
      removalDateAction: PropTypes.oneOf(["Unpublished", "Archived"]),
      approvalStatus: PropTypes.oneOf([
        "Management Approved",
        "Let Diamonds Approve",
      ]),
    }),
    information: PropTypes.shape({
      header: PropTypes.shape({
        preTitle: PropTypes.string,
        preTitleColor: PropTypes.string,
        headerTitle: PropTypes.string,
        headerTitleColor: PropTypes.string,
        subTitle: PropTypes.string,
        subTitleColor: PropTypes.string,
      }),
      details: PropTypes.shape({
        sku: PropTypes.string,
        skuColor: PropTypes.string,
        creator: PropTypes.string,
        creatorColor: PropTypes.string,
        detailsTitle: PropTypes.string,
        detailsTitleColor: PropTypes.string,
      }),
      icon: PropTypes.shape({
        iconType: PropTypes.oneOf([
          "DR",
          "DS",
          "DN",
          "ER",
          "FR",
          "FMA",
          "FE",
          "SP",
          "SL",
          "3P",
          "Compass",
        ]),
        iconTitle: PropTypes.string,
        iconTitleColor: PropTypes.string,
        iconAlign: PropTypes.oneOf(["left", "center", "right"]),
      }),
      gradient: PropTypes.shape({
        angle: PropTypes.string,
        gradientColors: PropTypes.arrayOf(PropTypes.string),
      }),
    }),
  }),
  /**
   * Function that sets the value of the feedItem prop.
   */
  setFeedItem: PropTypes.func,
};

BannerDropdownList.defaultProps = {
  feedItem: {
    type: "Banner",
    options: {
      title: "* NEW BANNER *",
      permissions: ["IBO", "PLA", "EM", "DIA"],
      familyReunions: [],
      diamonds: "",
      groups: "",
      incompatiblePlatforms: [],
      publishStatus: "Unpublished",
      publishDate: "",
    },
  },
};
